export default {
    resetStateMutation() { },
}
